export const PACKAGE_NAME = '@atlassian/jira-recommend-premium-to-standard-modal';
export const TEAM_NAME = 'growth-tako';
export const ANALYTICS_SOURCE_NAME = 'recommendPremiumToStandard';
export const STARGATE_URL = '/gateway/api';
export const RECC_STANDARD_MESSAGE_ID = new Map([
	[5, 'prj-grace-period-recc-standard-msg-1'],
	[3, 'prj-grace-period-recc-standard-msg-2'],
	[1, 'prj-grace-period-recc-standard-msg-3'],
]);
